const setSelectedProduct = (set, get, product) => {
  set({ selectedProduct: product });
};

const clearSelectedProduct = (set) => {
  set({ selectedProduct: null });
};

const getSelectedProduct = (get) => {
  return get().selectedProduct;
};

export {
  setSelectedProduct,
  clearSelectedProduct,
  getSelectedProduct,
};
